import styled from 'styled-components';
import { Typography } from '../ui/Typography';
import { FlexColumn } from '../../styled/common';

export const Title = styled(Typography).attrs({ tag: 'h4' })`
  font-weight: bold;
  font-size: 22px;
  margin: 0 0 35px;
  cursor: default;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    font-size: 32px;
  }
`;

export const FormContainer = styled(FlexColumn)`
  gap: 20px;
`;

export const FullWidthContainer = styled.div<{
  $isMobile: boolean;
}>`
  width: 100%;
  margin: ${({ $isMobile }) => ($isMobile ? '50px 0 auto' : 0)};
`;

export const ErrorMessage = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.red};
`;
